<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">{{ $t('master.textRute') }}.</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/master" />
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <div class="tab-button-service-schedule mc-btn--tab">
          <b-form-radio-group
            v-if="hasAccess(['d7b-default-md-ritage:read'])"
            id="tab-service-schedule"
            v-model="selectedTab"
            :options="tabOptions"
            name="tab-service-schedule"
            buttons
          />
        </div>
      </div>
      <div class="col-md-4 text-end">
        <McButton
          v-if="
            ((selectedTab === 'Route' && selectedIdsLength) ||
              (selectedTab === 'Ritage' && ritageSelectedIdsLength)) &&
            hasAccess(['d7a-default-md-route:delete'])
          "
          variant="secondary-red"
          class="ms-2"
          icon="icon-outline_trash"
          :text="$t('global.delete')"
          @click="$refs['modal-delete'].show()"
        />
        <b-dropdown
          v-if="
            ((selectedTab === 'Route' && selectedIdsLength) ||
              (selectedTab === 'Ritage' && ritageSelectedIdsLength)) &&
            hasAccess(['d7a-default-md-route:update'])
          "
          variant="outline-primary"
          class="ms-2"
        >
          <template #button-content>
            {{ $t('global.action.changeStatus') }}
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item @click="showUpdateStatus('I')">{{
            $t('master.status.aktif')
          }}</b-dropdown-item>
          <b-dropdown-item @click="showUpdateStatus('A')">{{
            $t('master.status.arsip')
          }}</b-dropdown-item>
        </b-dropdown>
        <McButton
          v-if="hasAccessAll(['geofences:read', 'd7a-default-md-route:create'])"
          variant="primary"
          icon="icon-outline_plus"
          :text="$t('global.create')"
          class="ms-2"
          @click="handleAdd"
        />
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <!-- Table -->
        <div v-show="selectedTab === 'Route'">
          <SearchAndFilter
            :selectedIdsLength="selectedIdsLength"
            :search="search"
            :filterStatus="filterStatus"
            :isBusy="isBusy"
            :handleSearchChange="handleSearchChange"
            :handleUnselectAll="handleUnselectAll"
            :updateFilterStatus="updateFilterStatus"
          />
          <div class="table-responsive my-3 border border-1">
            <div class="datatables table-responsive-lg">
              <table class="table b-table table-lg" aria-describedby="Rute">
                <thead>
                  <tr>
                    <th id="checkbox" rowspan="2" class="mc-table--30">
                      <div class="form-check">
                        <b-form-checkbox
                          v-model="selectedAll"
                          :disabled="isBusy"
                          @change="handleSelectAll"
                        />
                      </div>
                    </th>
                    <th id="routeName" rowspan="2">
                      {{ $t('master.list.route.routeName') }}
                    </th>
                    <th id="routeStatus" rowspan="2">
                      {{ $t('master.list.route.status') }}
                    </th>
                    <th id="routePrimary" colspan="3" class="text-center">
                      {{ $t('master.list.route.routePrimary') }}
                    </th>
                    <th id="routeAlternative" colspan="3" class="text-center">
                      {{ $t('master.list.route.routeAlternative') }}
                    </th>
                  </tr>
                  <tr>
                    <th id="listAddress" class="mc-table--20p">
                      {{ $t('master.list.route.listAddress') }}
                    </th>
                    <th id="mileage">
                      {{ $t('master.list.route.mileage') }}
                    </th>
                    <th id="estTime">
                      {{ $t('master.list.route.estTime') }}
                    </th>
                    <th id="listAddress" class="mc-table--20p">
                      {{ $t('master.list.route.listAddress') }}
                    </th>
                    <th id="mileage">
                      {{ $t('master.list.route.mileage') }}
                    </th>
                    <th id="estTime">
                      {{ $t('master.list.route.estTime') }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="items.length > 0">
                  <tr v-for="route in items" :key="route.id">
                    <td>
                      <div class="form-check">
                        <b-form-checkbox
                          :disabled="isBusy"
                          :checked="selectedIds[route.id]"
                          @change="(event) => handleSelect(event, route.id)"
                        />
                      </div>
                    </td>
                    <td>
                      <strong class="text-primary" @click="handleClickRow(route.id)">
                        {{ route.name }}
                      </strong>
                    </td>
                    <td>
                      <span v-if="route.status == 'I'" class="mc-status mc-status--green">
                        {{ $t('master.status.aktif') }}
                      </span>
                      <span v-else class="mc-status mc-status--grey">
                        {{ $t('master.status.arsip') }}
                      </span>
                    </td>
                    <td>
                      {{
                        route.master_route_address.length > 35
                          ? route.master_route_address.substring(0, 35)
                          : route.master_route_address
                      }}
                      <i
                        v-if="route.master_route_address.length > 35"
                        v-b-tooltip.hover
                        class="mc-fa icon-fill_more-horizontal"
                        :title="route.master_route_address"
                      ></i>
                    </td>
                    <td>{{ route.master_distance_label }}</td>
                    <td>{{ route.master_eta_time_label }}</td>
                    <td>
                      {{
                        route.alternative_route_address.length > 35
                          ? route.alternative_route_address.substring(0, 35)
                          : route.alternative_route_address
                      }}
                      <i
                        v-if="route.alternative_route_address.length > 35"
                        v-b-tooltip.hover
                        class="mc-fa icon-fill_more-horizontal"
                        :title="route.alternative_route_address"
                      ></i>
                    </td>
                    <td>{{ route.alternative_distance_label }}</td>
                    <td>{{ route.alternative_eta_time_label }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="text-center">{{ $t('global.emptyTable') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  {{ $t('global.show') }}
                  <b-form-select
                    class="form-select form-select-sm"
                    :disabled="isBusy"
                    :options="limitOptions"
                    :value="limit"
                    @input="handleLimitChange"
                  />
                  <strong>{{ startData }}</strong> - <strong>{{ endData }}</strong>
                  {{ $t('global.object.of') }} <strong>{{ totalCount }}</strong>
                  {{ $t('global.text.data') }}
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    :disabled="isBusy"
                    :per-page="limit"
                    :total-rows="totalCount"
                    :value="page"
                    @change="handlePageChange"
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-show="selectedTab === 'Ritage'" v-if="hasAccess(['d7b-default-md-ritage:read'])">
          <McEditableTable
            ref="ritageTableRef"
            :fields="ritageFields"
            :apiClient="ritageReq"
            :isPredefined="false"
            :searchable="true"
            :idIsString="true"
            :selectEvent="ritageTableSelectEvent"
            :editNeedAllData="true"
            trackBy="category"
            :cancelEditNeedRefetch="true"
            :insideCard="false"
          >
            <template #search="data">
              <SearchAndFilter
                :selectedIdsLength="data.selectedIdsLength"
                :search="data.search"
                :filterStatus="ritageFilterStatus"
                :isBusy="data.isBusy"
                :handleSearchChange="data.handleSearchChange"
                :handleUnselectAll="data.handleUnselectAll"
                :updateFilterStatus="updateRitageFilterStatus"
              />
            </template>
            <template #cell(createdDate)="data">
              <div v-if="data.item.created_on">
                {{ momentDateLongMonth(data.item.created_on) }}
                <p class="text-secondary">
                  {{ momentTimeSeconds(data.item.created_on) }}
                </p>
              </div>
            </template>
          </McEditableTable>
        </div>
      </div>
    </div>
    <b-modal
      id="mc-modal-update"
      ref="mc-modal-update"
      class="mc-modal"
      :title="$t('global.action.changeStatus')"
      body-class="p-3"
      size="md"
      centered
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('global.text.modal.changeStatus') }}
          {{ selectedTab === 'Route' ? selectedIdsLength : ritageSelectedIdsLength }}
          {{ $t('global.text.modal.changeStatusLength') }}
          <b v-if="status === 'I'">{{ $t('master.status.aktif') }}</b>
          <b v-if="status === 'A'">{{ $t('master.status.arsip') }}</b> ?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              :text="$t('global.action.cancel')"
              variant="secondary"
              class="me-2"
              @click="cancel()"
            />
            <McButton :text="$t('global.action.change')" variant="primary" @click="handleUpdate" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      id="modal-delete"
      ref="modal-delete"
      class="mc-modal"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.confirmDelete1') }}
          <strong>{{
            selectedTab === 'Route' ? selectedIdsLength : ritageSelectedIdsLength
          }}</strong>
          {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.action.cancel')"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.action.delete')" @click="handleDelete" />
        </div>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { debounce } from '@/helpers/debounce'
import * as routeApi from '@/services/rest-api-vsms/lib/route/route'
import { mapGetters } from 'vuex'
import McEditableTable from '@/components/McEditableTable'
import * as ritageApi from '@/services/rest-api-vsms/lib/route/ritage'
import SearchAndFilter from './SearchAndFilter/index.vue'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McEditableTable,
    SearchAndFilter,
    McButton,
    McButtonBack,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      page: 1,
      limit: 10,
      totalCount: 0,
      isBusy: true,
      search: '',
      sorts: [],
      items: [],
      ids: [],
      rowUpdate: {},
      selectedIds: {},
      selectedIdsLength: 0,
      selectedAll: false,
      limitOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'compName',
      filterStatus: {
        all: true,
        active: false,
        archive: false,
      },
      status: '',
      ritageSelectedIds: {},
      ritageSelectedIdsLength: 0,
      selectedTab: 'Route',
      isReturnRouteDisplayed: false,
      departureRouteValue: {},
      ritageFilterStatus: {
        all: true,
        active: false,
        archive: false,
      },
      ritageDatas: [],
      initEdit: false,
      startGeofenceId: -1,
      endGeofenceId: -1,
      routeStatus: null,
    }
  },
  computed: {
    title() {
      return this.$t('master.rute')
    },
    startData() {
      return this.limit * this.page - this.limit + 1
    },
    endData() {
      const _endData = this.limit * this.page
      return this.totalCount < _endData ? this.totalCount : _endData
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    tabOptions() {
      return [
        {
          text: `${this.$t('route.route')}`,
          value: 'Route',
        },
        {
          text: `${this.$t('route.ritage')}`,
          value: 'Ritage',
        },
      ]
    },
    ritageFields() {
      return [
        {
          key: 'ritage_name',
          name: 'name',
          label: this.$t('master.list.ritage.ritageName'),
          placeholder: this.$t('master.list.ritage.ritageNamePlaceholder'),
          isEditable: true,
          isSortable: false,
          validation: [['required']],
          thClass: 'mc-table--500',
        },
        {
          key: 'departure_route_name',
          name: 'departureRouteId',
          label: this.$t('master.list.ritage.departureRoute'),
          thClass: 'mc-table--170',
          placeholder: this.$t('master.list.ritage.departureRoutePlaceholder'),
          isEditable: true,
          isSortable: false,
          type: 'select-resourceful',
          optionsGetter: async (opts) => {
            opts['filters'] = [`status eq 'I'`, `usage eq 'ritage-dropdown'`]
            return this.resourcefulQuery.getRoutes(opts)
          },
          optionLabelFn: ({ item }) => item.name,
          getInitialObject: (item) => {
            return { id: item.departure_route_id, name: item.departure_route_name }
          },
          customValueFn: (item) => item.departure_route_id,
          validation: [['required']],
          handleChange: (item) => {
            this.setDepartureRouteValue(item.id)
            this.setEndGeofenceId(item.master_route_start_address_id)
            this.setStartGeofenceId(item.master_route_end_address_id)
            this.setIsReturnRouteDisplayed(
              item != null &&
                item != undefined &&
                item != '' &&
                item.master_route_start_address_id != item.master_route_end_address_id
            )
          },
          handleInit: (item) => {
            this.setIsReturnRouteDisplayed(item != null && item != undefined && item != '')
          },
        },
        {
          key: 'return_route_name',
          name: 'returnRouteId',
          label: this.$t('master.list.ritage.returnRoute'),
          thClass: 'mc-table--170',
          placeholder: this.$t('master.list.ritage.returnRoutePlaceholder'),
          isEditable: this.isReturnRouteDisplayed,
          isSortable: false,
          type: 'select-resourceful',
          trackBy: 'id',
          optionsGetter: async (opts) => {
            opts['filters'] = [
              `status eq 'I'`,
              `end_geofence_id eq ${this.endGeofenceId}`,
              `usage eq ='ritage-dropdown'`,
            ]
            return this.resourcefulQuery.getRoutes(opts)
          },
          optionLabelFn: ({ item }) => item.name,
          getInitialObject: (item) => {
            return { id: item.return_route_id, name: item.return_route_name }
          },
          customValueFn: (item) => item.return_route_id,
        },
        {
          key: 'createdDate',
          label: this.$t('master.list.ritage.createdDate'),
          isEditable: false,
        },
      ]
    },
    ritageReq() {
      return {
        get: async (opts) => {
          const filter = {
            search: opts.search,
            limit: opts.limit,
            page: opts.page,
            filters: this.ritageFilterStatus.active
              ? `status eq 'I'`
              : this.ritageFilterStatus.archive
              ? `status eq 'A'`
              : '',
          }

          this.track('View List Ritage')
          const res = await ritageApi.get(filter)
          return res
        },
        store: async (data) => {
          this.track('Create Ritage')
          const res = await ritageApi.store(data)
          return res
        },
        update: async (id, data) => {
          const res = await ritageApi.update(id, data)
          if (!res.errors) {
            this.track('Update Ritage')
          }
          return res
        },
        updateStatus: async (input) => {
          const updatedData = await ritageApi.updateStatus(input)

          if (!updatedData) return false

          this.$refs.ritageTableRef.handleUnselectAll()
          const self = this
          self.ritageSelectedIdsLength = 0
          await this.getRitageData()
          return true
        },
        delete: async (ids) => {
          const res = await ritageApi.deleteMany({
            ids,
          })

          if (!res || res.errors) return res

          this.$refs.ritageTableRef.handleUnselectAll()
          const self = this
          self.ritageSelectedIdsLength = 0
          await this.getRitageData()
          return true
        },
        show: async (id) => {
          const res = await ritageApi.show(id)
          this.setIsReturnRouteDisplayed(
            res.data.return_route_id != null &&
              res.data.return_route_id != undefined &&
              res.data.return_route_id != ''
          )
          return res
        },
      }
    },
    routeReq() {
      return {
        updateStatus: async (input) => {
          const updatedData = await routeApi.updateStatus(input)
          if (!updatedData || updatedData.errors) return updatedData
          this.handleUnselectAll()
          await this.getData({
            limit: this.limit,
            page: 1,
          })
          return true
        },
        delete: async (ids) => {
          const res = await routeApi.deleteMany({
            ids,
          })

          if (!res || res.errors) return res

          this.handleSortChange()
          this.handleUnselectAll()

          if (this.search) this.setSearch('')
          await this.getData({
            limit: this.limit,
            page: 1,
          })
          return true
        },
      }
    },
    resourcefulQuery() {
      return {
        getRoutes: async (opts) => {
          const filter = {
            search: opts.search,
            limit: 10,
            page: opts.page,
            ...opts,
          }

          const res = await routeApi.get(filter)
          const data = res.data.paginated_result
          const result = {
            metadata: {
              total_page: res.metadata.total_page,
              total_count: res.metadata.total_count,
              page: res.metadata.page,
            },
            data: {
              paginated_result: data,
            },
          }
          return result
        },
      }
    },
  },
  watch: {
    departureRouteValue(newValue, oldValue) {
      if (
        this.$refs.ritageTableRef._data.formValues.departureRouteId !=
        this.$refs.ritageTableRef._data.initialFormValues.departureRouteId
      ) {
        this.$refs.ritageTableRef._data.formValues.returnRouteId = null
        this.$refs.ritageTableRef._data.items[
          this.$refs.ritageTableRef._data.isEditingRow
        ].return_route_name = null
      }
    },
    ritageFilterStatus: {
      handler: async function () {
        await this.getRitageData()
      },
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()
    await this.getData({
      limit: this.limit,
      page: this.page,
    })
    this.track('View List Route')
  },
  methods: {
    setIsReturnRouteDisplayed(value) {
      this.isReturnRouteDisplayed = value
    },
    setDepartureRouteValue(value) {
      this.departureRouteValue = value
    },
    setStartGeofenceId(value) {
      this.startGeofenceId = value
    },
    setEndGeofenceId(value) {
      this.endGeofenceId = value
    },
    setInitEdit(value) {
      this.initEdit = value
    },
    setSearch(value) {
      this.search = value
    },
    ritageTableSelectEvent(items) {
      this.ritageSelectedIds = items
      this.ritageSelectedIdsLength = Object.keys(items).filter((key) => items[key] === true).length
    },
    showSortIcon(data, order) {
      const currentColumnSort = this.sorts.find((sort) => sort.key === data.field.key)
      if (!currentColumnSort) {
        return true
      }

      return currentColumnSort.key === data.field.key && currentColumnSort.order === order
    },
    async getData(opts) {
      this.isBusy = true
      const res = await routeApi.get(opts)
      if (!res) return
      this.items = res.data.paginated_result
      this.ids = res.data.ids
      this.page = res.metadata.page
      this.totalCount = res.metadata.total_count
      this.isBusy = false
    },
    showAllStatus() {
      let obj = { ...this.filterStatus }
      Object.keys(obj).forEach(function (key) {
        obj[key] = key === 'all'
      })
      this.filterStatus = obj
      this.routeStatus = null
    },
    async updateFilterStatus(param) {
      for (const key in this.filterStatus) {
        if (key !== param) {
          this.filterStatus[key] = false
        }
      }
      this.filterStatus[param] = true
      await this.filterByStatus()
    },
    async filterByStatus() {
      this.limit = 10
      this.page = 1
      if (this.filterStatus.active) {
        this.routeStatus = `status eq 'I'`
        await this.getData({
          limit: this.limit,
          page: this.page,
          filters: this.routeStatus,
        })
      }

      if (this.filterStatus.archive) {
        this.routeStatus = `status eq 'A'`
        await this.getData({
          limit: this.limit,
          page: this.page,
          filters: this.routeStatus,
        })
      }

      // Check if all selected
      let obj = { ...this.filterStatus }
      let objArr = []
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(key)
        }
      })
      let exceptAll = Object.keys(obj).filter((key) => key != 'all').length
      if (objArr.length === exceptAll || objArr.length === 0 || objArr[0] === 'all') {
        this.showAllStatus()
        await this.getData({
          limit: this.limit,
          page: this.page,
        })
      }
    },
    handleSearchChange: debounce(async function (_search) {
      this.search = _search
      const opts = {
        limit: this.limit,
        search: _search != '' ? _search : undefined,
        page: 1,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
      }
      await this.getData(opts)
      this.$refs['search-input-ref'].$el.focus()
    }, 500),
    handleClickRow(id) {
      if (!this.hasAccessAll(['geofences:read', 'd7a-default-md-route:update'])) return
      this.$router.push({ name: 'Master Route Update', params: { id: id } })
    },
    async handleLimitChange(_limit) {
      this.limit = _limit

      await this.getData({
        limit: _limit,
        search: this.search != '' ? this.search : undefined,
        page: 1,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
      })
    },
    async handlePageChange(newPage) {
      const opts = {
        page: newPage,
        search: this.search != '' ? this.search : undefined,
        limit: this.limit,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
        filters: this.routeStatus,
      }
      await this.getData(opts)
    },
    async handleSortChange(data) {
      // If this function is called without data params,
      // remove sorting (revert to default)
      if (!data) {
        this.sorts = []
        return
      }

      // If field not sortable or If currently editing a field, disable sort
      if (!data?.field?.isSortable) return

      // Get index of current column sort, if any
      const currentColumnSortIndex = this.sorts.findIndex((sort) => sort.key === data.field.key)
      // Get the sorting data (key, order)
      const currentColumnSort = this.sorts[currentColumnSortIndex]
      const newSorts = [...this.sorts]
      // This switch case is used to toggle between these conditions:
      // default - asc - desc - default (repeat)
      switch (currentColumnSort?.order) {
        case 'asc':
          newSorts[currentColumnSortIndex] = {
            key: currentColumnSort.key,
            order: 'desc',
          }
          break

        case 'desc':
          newSorts.splice(currentColumnSortIndex, 1)
          break

        default:
          newSorts.push({ key: data.field.key, order: 'asc' })
          break
      }

      this.sorts = [...newSorts]
      await this.$nextTick()

      await this.getData({
        limit: this.limit,
        page: 1,
        search: this.search != '' ? this.search : undefined,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
      })
    },
    handleSelect(checked, data) {
      this.selectedIds = { ...this.selectedIds, [data]: checked }
      if (checked) {
        this.selectedIdsLength += 1
        if (this.selectedIdsLength == this.ids.length) this.selectedAll = true
      } else {
        this.selectedIdsLength -= 1
      }
    },
    handleSelectAll(event) {
      if (event) {
        this.selectedIds = Object.fromEntries(this.ids.map((key) => [key, true]))
        this.selectedIdsLength = this.ids.length ?? 0
        this.selectedAll = true
      } else {
        this.handleUnselectAll()
      }
    },
    handleUnselectAll() {
      this.selectedIds = {}
      this.selectedAll = false
      this.selectedIdsLength = 0
    },
    async handleDelete() {
      const selectedIds = this.selectedTab === 'Route' ? this.selectedIds : this.ritageSelectedIds
      const _selected = Object.keys(selectedIds).filter((key) => selectedIds[key] === true)
      const ids = _selected.map((str) => parseInt(str))
      let res =
        this.selectedTab === 'Route'
          ? await this.routeReq.delete(ids)
          : await this.ritageReq.delete(ids)

      if (!res) {
        this.$mcToast.error(this.$t('global.alert.text.failDelete'))
      } else {
        if (res.errors) {
          if (
            res.errors.includes(
              'Cannot delete ritage because it is still active or is being used on master route or route planning.'
            )
          ) {
            this.$mcToast.error(this.$t('global.alert.text.ritageIsUsed'))
          } else {
            this.$mcToast.error(res.errors)
          }
        } else {
          this.$mcToast.success(this.$t('global.alert.text.delete'))
          if (this.selectedTab === 'Route') {
            this.track('Delete Route')
          } else {
            this.track('Delete Ritage')
          }
        }
      }
      this.$refs['modal-delete'].hide()
    },
    showUpdateStatus(status) {
      this.status = status
      this.$bvModal.show('mc-modal-update')
    },
    handleAdd() {
      if (this.selectedTab === 'Route') {
        this.$router.push({ name: 'Master Route Create' })
      } else if (this.selectedTab === 'Ritage') {
        this.$refs.ritageTableRef.handleAdd()
      }
    },
    async updateRitageFilterStatus(param) {
      for (const key in this.ritageFilterStatus) {
        if (key !== param) {
          this.ritageFilterStatus[key] = false
        }
      }
      this.ritageFilterStatus[param] = true
    },
    async handleUpdate() {
      const selectedIds = this.selectedTab === 'Route' ? this.selectedIds : this.ritageSelectedIds
      const _selected = Object.keys(selectedIds).filter((key) => selectedIds[key] === true)
      const ids = _selected.map((str) => parseInt(str))
      const input = { ids: ids, status: this.status }
      const updatedData =
        this.selectedTab === 'Route'
          ? await this.routeReq.updateStatus(input)
          : await this.ritageReq.updateStatus(input)

      if (!updatedData) {
        this.$mcToast.error('Data gagal diubah')
      } else {
        if (updatedData.errors) {
          this.$mcToast.error(updatedData.errors)
        } else {
          this.$mcToast.success('Data berhasil diubah')
          if (this.selectedTab === 'Route') {
            this.track('Change Status Route')
          } else {
            this.track('Change Status Ritage')
          }
        }
      }

      this.$refs['mc-modal-update'].hide()
    },
    async getRitageData() {
      await this.$refs.ritageTableRef.getData({
        limit: this.$refs.ritageTableRef.limit,
        page: 1,
        search:
          this.$refs.ritageTableRef.search != '' ? this.$refs.ritageTableRef.search : undefined,
        sorts: this.$refs.ritageTableRef.sorts.map((sort) => `${sort.key} ${sort.order}`),
      })
    },
  },
}
</script>
